import { apiService } from './api';

export type RoomType = 'classroom' | 'lab' | 'computer_lab' | 'auditorium' | 'library' | 'sports' | 'other';

export interface Room {
  _id: string;
  name: string;
  type: RoomType;
  capacity: number;
  description?: string;
  facilities?: string[];
  schoolId: any;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface RoomFormData {
  name: string;
  type: RoomType;
  capacity: number;
  description?: string;
  facilities?: string[];
  schoolId?: string;
}

export interface RoomStats {
  total: number;
  active: number;
  inactive: number;
  byType: Record<string, number>;
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const roomService = {
  // Get all rooms with pagination and filters
  getRooms: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    type?: string;
    isActive?: boolean;
    schoolId?: string;
  }) => {
    const response = await apiService.get<{
      rooms: Room[];
      pagination: Pagination;
    }>('/timetable/rooms', params);
    return response.data;
  },

  // Get single room by ID
  getRoom: async (id: string) => {
    const response = await apiService.get<Room>(`/timetable/rooms/${id}`);
    return response.data;
  },

  // Create new room
  createRoom: async (data: RoomFormData) => {
    const response = await apiService.post<Room>('/timetable/rooms', data);
    return response.data;
  },

  // Update room
  updateRoom: async (id: string, data: Partial<RoomFormData> & { isActive?: boolean }) => {
    const response = await apiService.put<Room>(`/timetable/rooms/${id}`, data);
    return response.data;
  },

  // Delete room (soft delete)
  deleteRoom: async (id: string) => {
    const response = await apiService.delete(`/timetable/rooms/${id}`);
    return response.data;
  },

  // Get room statistics
  getRoomStats: async (schoolId?: string) => {
    const params = schoolId ? { schoolId } : {};
    const response = await apiService.get<RoomStats>('/timetable/rooms/stats', params);
    return response.data;
  },
};
